import React, { useEffect, useState } from "react";
import moment from "moment";
import { baseUrl } from "../constants/url";
import axios from "axios";
import "./style.css";
import { api } from "../constants/api";

const CricketCalenderView = () => {
  const [availableSlots, setAvailableSlots] = useState([
    [{ startTime: "", endTime: "", amount: 0, isBooked: false }],
  ]);
  const [showUser, setShowUser] = useState(true)
  const [memberInfo, setMemberInfo] = useState<any>({})
  const [memberLoading, setMemberLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  const weekDates = () => {
    const today = moment();
    var dateArray = [today];

    for (let i = 0; i < 6; i++) {
      dateArray.push(moment(dateArray[i]).add(1, "days"));
    }

    return dateArray;
  };

  const getMemberInfo = async () => {
    try {
      setMemberLoading(true)
      const res = await api(true, `/admin/get-all-members`, 'get')
      const data:any = {}
      for(let member of (res?.data?.data?.result || [])) {
        data[member.idNumber] = member
      }
      setMemberInfo(data)
    } catch(error) {
      console.log(error, ' <== Error while fetching member info')
    } finally{
      setMemberLoading(false)
    }
  }

  const getAvailableSlots = async () => {
    setLoading(true)
    const dateList = weekDates();
    let slotObj = [];

    for (let i = 0; i < dateList.length; i++) {
      const res = await api(true, `/admin/availableslots?date=${moment(dateList[i]).format("YYYY-MM-DD")}&sport=CRICKET`, 'get')
      // axios.get(
      //   `${baseUrl}/availableslots?date=${moment(dateList[i]).format(
      //     "YYYY-MM-DD"
      //   )}`
      // );

      slotObj.push(res.data);
    }
    setAvailableSlots(slotObj);
    setLoading(false)
    return slotObj;
  };

  const setDefaultHeader = () => {
    if (
      localStorage.getItem("lastAuthTimeMillis") &&
      // @ts-ignore
      parseInt(localStorage.getItem("lastAuthTimeMillis")) >
        new Date().getTime() - 30 * 60 * 1000
    ) {
      // @ts-ignore
      axios.defaults.headers.common["MemberCode"] =
        localStorage.getItem("MemberCode");
      // @ts-ignore
      axios.defaults.headers.common["MemberId"] =
        localStorage.getItem("MemberId");
      // @ts-ignore
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("Authorization");
    } else {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    // setDefaultHeader();
    getAvailableSlots();
    getMemberInfo();
  }, []);

  if(loading) {
    return (
      <p>
        Loading...
      </p>
    )
  }

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">Slot Availability for Cricket</h2>
      <button onClick={() => setShowUser(!showUser)}> {showUser ? 'Hide' : 'Show'} User Details</button>
      <div className="responsive-table-container">
        <div className="styled-table">
          <table style={{ marginLeft: "auto", marginRight: "auto" }}>
            <thead>
              <tr>
                <th>Slots</th>
                {weekDates().map((date, index) => (
                  <th key={index}>{moment(date).format("DD-MM-YYYY")}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <td>
                {availableSlots[0].map(item => (
                  <tr className="row" style={{ height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <td>

                    <span>
                      {moment(item.startTime).format("LT")}
                    </span>
                    </td>
                    {/* -
                    <span>
                      {moment(item.endTime).format("LT")}
                    </span> */}
                  </tr>
                ))}
              </td>
              {availableSlots.map((item, index) => {
                return (
                  <td>
                    {item.map((item2:any) => {
                      return (
                        <>
                          {item2.isBooked === true ? (
                            item2.bookingStatus === "success" ? (
                              <tr
                                style={{
                                  fontSize: 10,
                                  height: 100,
                                  width: 100,
                                  textAlign: "center",
                                  background: "red",
                                }}
                              >
                                <td className="slot-booked-cell">
                                  <div className="centered-content" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                    <p style={{ maxWidth: 100, color: 'white', fontWeight: 'bold', textAlign: "center" }}>
                                      {memberLoading ? 'Loading...' : showUser ? `Booked by ${(memberInfo[item2?.user_id]?.memberName || item2?.user_id)}` : 'Booked'}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            ) : item2.bookingStatus === "pending" ? (
                              <tr
                                style={{
                                  fontSize: 12,
                                  height: 100,
                                  width: 100,
                                  textAlign: "center",
                                  background: "#FFF9C4", // light yellow
                                }}
                              >
                                <td>
                                  <div className="centered-content">
                                    <p style={{ maxWidth: 100, color: '#333', fontWeight: 'bold' }}>Booking is ongoing</p>
                                  </div>
                                </td>
                              </tr>
                            ) : null
                          ) : (
                            <tr
                              style={{
                                fontSize: 15,
                                height: 100,
                                width: 100,
                                textAlign: "center",
                                background: "green",
                              }}
                            >
                              <td>
                                <div className="centered-content">
                                  <div style={{ height: 60, width: 100 }}></div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </td>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CricketCalenderView;
